import {Injectable} from '@angular/core';
import {DataCoreService, DlistDto} from '@dabnet-kamu/libs/ui';
import {BehaviorSubject} from 'rxjs';
import {HttpClient} from '@angular/common/http';
import {ControlConditionModel} from "../../../models/gen-control.model";

@Injectable()
export class TemTaahhutService {
  public period!: number;
  public kurumsalKod!: string;
  public codeField: any;
  public isReadOnly!: boolean;
  public isBindCheck!: boolean;
  public controlCondition: ControlConditionModel[];
  public _gridControlsList: BehaviorSubject<DlistDto | null> = new BehaviorSubject(null);
  public gridControlsList$ = this._gridControlsList.asObservable();

  constructor(private dataCoreService: DataCoreService, private _httpClient: HttpClient) {
  }


  setParams(period: number, kurumsalKod: string, codeField?: any, controlCondition?: ControlConditionModel[],isReadOnly?:boolean, isBindCheck?:boolean) {
    this.period = period;
    this.kurumsalKod = kurumsalKod;
    this.codeField = codeField;
    this.controlCondition=controlCondition
    this.isReadOnly = isReadOnly;
    this.isBindCheck = isBindCheck;
  }


  getData(code: number,control:any, period: number, kurumsalKod?: any, baseEntity?: string, isSetData?: boolean) {
     let dataSource: any;
     let tableName = "";
    const filterArr = [];
      if (this.isBindCheck && this.isReadOnly){
      tableName = control.showEntity?control.showEntity:control.dlistMetadata.baseEntity;
      dataSource = this.dataCoreService.getOData(tableName);
    dataSource.select([]);
    } 
    else{
      dataSource = this.dataCoreService.getOData(baseEntity);
    dataSource.select([]);
    if (kurumsalKod) filterArr.push(['KurumsalKod', '=', kurumsalKod]);
    if (period) filterArr.push(['Donem', '=', period]);
    if(this.controlCondition){
      this.controlCondition.forEach((item:any) => {
          filterArr.push([item.conditionColName, item.conditionColSymbol, item.conditionColText]);
      });
    }
    }
    if (code) filterArr.push([this.codeField, '=', code]);
    if (filterArr.length > 0) dataSource.filter(filterArr);
    return dataSource;
  }
}
